export class FileExtended {
  public file: File;
  public fileUrl: string;

  constructor(file: File) {
    this.file = file;
    this.fileUrl = URL.createObjectURL(file);
  }
}